
// import React, { useState, useEffect, useMemo, useRef  } from 'react';
// import PortfolioOverview from './PortfolioOverview';
// import { LogOut, ArrowDown, ArrowUp, Download, Wallet, TrendingUp, DollarSign, Target, Users, AlertCircle, Info, User, RefreshCw, ChevronRight, Menu, X, Clock } from "lucide-react";
// import { Avatar, AvatarFallback, AvatarImage } from "./ui/Avatar";
// import { Button } from "./ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "./ui/cards";
// import StrategiesSection from './StrategiesSection';
// import ProfileSection from './ProfileSection';
// import Breadcrumb from './Breadcrumb';
// import SIPDashboard from './SIPDashboard';
// import AddFundsSection from './AddFundsSection';
// import { createClient } from '@supabase/supabase-js';

// const supabase = createClient(
//   process.env.REACT_APP_SUPABASE_URL,
//   process.env.REACT_APP_SUPABASE_ANON_KEY
// );
// // Strategy Selection Modal Component
// const StrategySelectionModal = ({ isOpen, onClose, strategies, clickedStrategy, onProceedToInvestment }) => {
//   const [selectedStrategies, setSelectedStrategies] = useState([]);

//   useEffect(() => {
//     if (isOpen && clickedStrategy) {
//       setSelectedStrategies([clickedStrategy.id]);
//     } else if (!isOpen) {
//       setSelectedStrategies([]);
//     }
//   }, [isOpen, clickedStrategy]);

//   const handleStrategyToggle = (strategyId) => {
//     setSelectedStrategies(prev => 
//       prev.includes(strategyId) 
//         ? prev.filter(id => id !== strategyId)
//         : [...prev, strategyId]
//     );
//   };

//   const handleProceed = () => {
//     if (selectedStrategies.length > 0) {
//       const selectedStrategyObjects = strategies.filter(s => selectedStrategies.includes(s.id));
//       onProceedToInvestment(selectedStrategyObjects);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//       <div className="bg-[#151515] border border-white/10 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
//         <div className="p-6 border-b border-white/10">
//           <div className="flex justify-between items-center">
//             <h2 className="text-xl font-semibold text-white" style={{fontFamily: 'Lexend, sans-serif'}}>
//               Select Investment Strategies
//             </h2>
//             <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
//               <X className="h-5 w-5" />
//             </button>
//           </div>
//           <p className="text-gray-400 mt-2">Choose one or more strategies to invest in:</p>
//         </div>
        
//         <div className="p-6 max-h-96 overflow-y-auto">
//           <div className="space-y-4">
//             {strategies.filter(s => s.status !== 'Closed').map((strategy) => (
//               <div 
//                 key={strategy.id}
//                 className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
//                   selectedStrategies.includes(strategy.id) 
//                     ? 'border-[#676DFF] bg-[#676DFF]/5' 
//                     : 'border-white/20 hover:border-white/30'
//                 }`}
//                 onClick={() => handleStrategyToggle(strategy.id)}
//               >
//                 <div className="flex items-start space-x-3">
//                   <div className="flex-shrink-0 mt-1">
//                     <input
//                       type="checkbox"
//                       checked={selectedStrategies.includes(strategy.id)}
//                       onChange={() => handleStrategyToggle(strategy.id)}
//                       className="w-4 h-4 text-[#676DFF] border-gray-300 rounded focus:ring-[#676DFF]"
//                     />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <div className="flex justify-between items-start">
//                       <div>
//                         <h3 className="text-lg font-medium text-white" style={{fontFamily: 'Lexend, sans-serif'}}>
//                           {strategy.name}
//                         </h3>
//                         <p className="text-sm text-gray-400 mt-1">{strategy.briefSummary}</p>
//                       </div>
//                       <div className="text-right ml-4">
//                         <div className="text-sm font-medium text-gray-400">Category</div>
//                         <div className="text-lg font-semibold text-emerald-400">{strategy.category}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="p-6 border-t border-white/10">
//           <div className="flex justify-between items-center">
//             <div className="text-sm text-gray-400">
//               {selectedStrategies.length} strategy(ies) selected
//             </div>
//             <div className="flex space-x-3">
//               <button
//                 onClick={onClose}
//                 className="px-4 py-2 text-gray-400 border border-white/20 rounded-lg hover:bg-white/5 transition-colors"
//                 style={{fontFamily: 'Lexend, sans-serif'}}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleProceed}
//                 disabled={selectedStrategies.length === 0}
//                 className="px-6 py-2 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
//                 style={{fontFamily: 'Lexend, sans-serif'}}
//               >
//                 Proceed to Investment
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // KYC Status Modal Component 
// const KYCStatusModal = ({ isOpen, onClose, kycStatus, onNavigateToProfile }) => {
//   if (!isOpen) return null;

//   const getStatusConfig = () => {
//     switch (kycStatus) {
//       case 'not_completed':
//         return {
//           icon: <AlertCircle className="h-12 w-12 text-amber-500" />,
//           title: "Complete KYC to Start Investing",
//           message: "Please complete your KYC verification to access our investment strategies.",
//           buttonText: "Complete KYC",
//           buttonClass: "bg-amber-500 hover:bg-amber-600",
//           action: () => { onNavigateToProfile(); onClose(); }
//         };
//       case 'under_review':
//         return {
//           icon: <Clock className="h-12 w-12 text-blue-500" />,
//           title: "KYC Under Review",
//           message: "Your KYC is currently under review. Once approved, you can begin investing.",
//           buttonText: "Check Status",
//           buttonClass: "bg-blue-500 hover:bg-blue-600",
//           action: () => { onNavigateToProfile(); onClose(); }
//         };
//       default:
//         return null;
//     }
//   };

//   const config = getStatusConfig();
//   if (!config) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//       <div className="bg-[#151515] border border-white/10 rounded-xl p-6 lg:p-8 max-w-md w-full">
//         <div className="flex justify-between items-start mb-6">
//           <div className="text-center flex-1">
//             <div className="flex justify-center mb-4">{config.icon}</div>
//             <h3 className="text-xl font-semibold text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>{config.title}</h3>
//             <p className="text-gray-300 text-sm">{config.message}</p>
//           </div>
//           <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
//             <X className="h-5 w-5" />
//           </button>
//         </div>
        
//         <div className="flex space-x-3">
//           <button
//             onClick={onClose}
//             className="flex-1 border border-white/20 text-gray-300 hover:bg-white/5 font-medium py-3 px-4 rounded-lg transition-colors"
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={config.action}
//             className={`flex-1 text-white font-medium py-3 px-4 rounded-lg transition-colors ${config.buttonClass}`}
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             {config.buttonText}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Investment Modal Component
// const InvestmentModal = ({ isOpen, onClose, strategy, userStatus, client }) => {
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formData, setFormData] = useState({
//     selectedStrategy: strategy?.id || '',
//     amount: '',
//     riskAppetite: 'medium',
//     comments: ''
//   });

//   useEffect(() => {
//     if (strategy) {
//       const strategyId = Array.isArray(strategy) ? strategy[0]?.id : strategy.id;
//       setFormData(prev => ({ ...prev, selectedStrategy: strategyId }));
//     }
//   }, [strategy]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     try {
//       setIsSubmitting(true);
      
//       const userData = {
//         client_id: userStatus?.id || client?.id,
//         client_name: userStatus?.name || client?.Name,
//         client_email: userStatus?.email || client?.email,
//         client_phone: userStatus?.phone || client?.phone
//       };

//       const strategiesArray = Array.isArray(strategy) ? strategy : [strategy];
//       const selectedStrategyIds = strategiesArray.map(s => s.id || s.strategyId);
//       const strategyNames = strategiesArray.map(s => s.name);

//       const investmentData = {
//         ...userData,
//         selected_strategies: selectedStrategyIds,
//         strategy_names: strategyNames,
//         investment_amount: parseFloat(formData.amount),
//         risk_appetite: formData.riskAppetite,
//         comments: formData.comments,
//         status: 'pending'
//       };

//       const { data, error } = await supabase
//         .from('investment_requests')
//         .insert([investmentData])
//         .select();

//       if (error) {
//         throw error;
//       }

//       setFormData({
//         selectedStrategy: '',
//         amount: '',
//         riskAppetite: 'medium',
//         comments: ''
//       });
//       onClose();

//       const strategyText = strategyNames.length > 1 
//         ? `${strategyNames.length} strategies (${strategyNames.join(', ')})`
//         : strategyNames[0];
      
//       alert(`Investment request submitted successfully for ${strategyText}! We will contact you shortly.`);

//     } catch (error) {
//       console.error('Error submitting investment request:', error);
//       alert('Failed to submit investment request. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//       <div className="bg-[#151515] border border-white/10 rounded-xl p-6 lg:p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-start mb-6">
//           <h3 className="text-xl font-semibold text-white" style={{fontFamily: 'Lexend, sans-serif'}}>Start Your Investment</h3>
//           <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
//             <X className="h-5 w-5" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label className="block text-sm font-medium text-gray-300 mb-2">
//               Selected Strateg{Array.isArray(strategy) && strategy.length > 1 ? 'ies' : 'y'}
//             </label>
//             <div className="bg-white/5 border border-white/10 rounded-lg p-3">
//               {Array.isArray(strategy) ? (
//                 <div className="space-y-2">
//                   {strategy.map((s, index) => (
//                     <div key={index} className="flex items-center justify-between">
//                       <span className="text-white font-medium">{s.name}</span>
//                       <span className="text-gray-400 text-sm">{s.category}</span>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="flex items-center justify-between">
//                   <span className="text-white font-medium">{strategy?.name}</span>
//                   <span className="text-gray-400 text-sm">{strategy?.category}</span>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-300 mb-2">Investment Amount (USD)</label>
//             <input
//               type="number"
//               value={formData.amount}
//               onChange={(e) => setFormData(prev => ({ ...prev, amount: e.target.value }))}
//               className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:border-[#676DFF] focus:outline-none"
//               placeholder="Enter amount"
//               min="100"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-300 mb-2">Risk Appetite</label>
//             <div className="grid grid-cols-3 gap-2">
//               {['low', 'medium', 'high'].map((risk) => (
//                 <button
//                   key={risk}
//                   type="button"
//                   onClick={() => setFormData(prev => ({ ...prev, riskAppetite: risk }))}
//                   className={`p-2 rounded-lg border transition-colors text-sm font-medium ${
//                     formData.riskAppetite === risk
//                       ? 'bg-[#676DFF] border-[#676DFF] text-white'
//                       : 'border-white/20 text-gray-300 hover:bg-white/5'
//                   }`}
//                 >
//                   {risk.charAt(0).toUpperCase() + risk.slice(1)}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-300 mb-2">Additional Comments</label>
//             <textarea
//               value={formData.comments}
//               onChange={(e) => setFormData(prev => ({ ...prev, comments: e.target.value }))}
//               className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:border-[#676DFF] focus:outline-none h-20 resize-none"
//               placeholder="Any specific requirements or questions..."
//             />
//           </div>

//           <div className="flex space-x-3">
//             <button
//               type="button"
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="flex-1 border border-white/20 text-gray-300 hover:bg-white/5 font-medium py-3 px-4 rounded-lg transition-colors disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={isSubmitting}
//               className="flex-1 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-gray-600 text-white font-medium py-3 px-4 rounded-lg transition-colors"
//             >
//               {isSubmitting ? 'Submitting...' : 'Submit Investment'}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// const ComprehensiveDashboard = ({ client, userStatus, onLogout, onStatusUpdate, dashboardData }) => {
//   const [activeSection, setActiveSection] = useState('strategies');
//   const [unifiedDashboardData, setUnifiedDashboardData] = useState(dashboardData);
//   const [investments, setInvestments] = useState([]);
//   const [sipData, setSipData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Mobile sidebar state
//   const scrollContainerRef = useRef(null);
//   const [showKYCModal, setShowKYCModal] = useState(false);
// const [showStrategySelectionModal, setShowStrategySelectionModal] = useState(false);
// const [showInvestmentModal, setShowInvestmentModal] = useState(false);
// const [clickedStrategy, setClickedStrategy] = useState(null);
// const [selectedStrategiesForInvestment, setSelectedStrategiesForInvestment] = useState([]);
// const [currentKycStatus, setCurrentKycStatus] = useState('not_completed');
// const [availableStrategies, setAvailableStrategies] = useState([]);
//   // Breadcrumb navigation state
//   const [breadcrumbPath, setBreadcrumbPath] = useState([]);
//   const [currentStrategy, setCurrentStrategy] = useState(null);
//   const [currentView, setCurrentView] = useState('list');

//   const handleContactAdvisor = () => {
//   const actualKycStatus = userStatus?.kycStatus || userStatus?.status || 'not_completed';
  
//   let mappedKycStatus;
//   if (actualKycStatus === 'verified' || actualKycStatus === 'approved') {
//     mappedKycStatus = 'approved';
//   } else if (actualKycStatus === 'pending' || actualKycStatus === 'under_review' || actualKycStatus === 'submitted') {
//     mappedKycStatus = 'under_review';
//   } else {
//     mappedKycStatus = 'not_completed';
//   }
  
//   if (mappedKycStatus === 'approved') {
//     setShowStrategySelectionModal(true);
//   } else {
//     setCurrentKycStatus(mappedKycStatus);
//     setShowKYCModal(true);
//   }
// };

// useEffect(() => {
//   setAvailableStrategies([
//     {
//       id: 'nexus-btc',
//       name: 'Nexus BTC',
//       briefSummary: 'Build long-term Bitcoin exposure with enhanced yield.',
//       category: 'Vault',
//       status: 'Live'
//     },
//     {
//       id: 'nexus-eth',
//       name: 'Nexus ETH',
//       briefSummary: 'Capture Ethereum\'s upside while compounding yield.',
//       category: 'Vault',
//       status: 'Live'
//     },
//     {
//       id: 'nexus-usd',
//       name: 'Nexus USD',
//       briefSummary: 'Stable, consistent yield from USD-pegged assets.',
//       category: 'Vault',
//       status: 'Live'
//     },
//     {
//       id: 'nexus-core',
//       name: 'Nexus Core',
//       briefSummary: 'The foundation of digital asset investing.',
//       category: 'Portfolio',
//       status: 'Open'
//     },
//     {
//       id: 'nexus-nova',
//       name: 'Nexus Nova',
//       briefSummary: 'Positioned for the next era of blockchain adoption.',
//       category: 'Portfolio',
//       status: 'Open'
//     },
//     {
//       id: 'nexus-alpha',
//       name: 'Nexus Alpha',
//       briefSummary: 'Harnessing early-stage innovation with active management.',
//       category: 'Portfolio',
//       status: 'Open'
//     },
//         {
//       id: 'sip-service',
//       category: 'SIP',
//       name: 'Systematic Investment Plan',
//       briefSummary: 'Automated recurring investments across our portfolio strategies with dollar-cost averaging.',
//       status: 'Open'
//     }
//   ]);
// }, []);

//   const scrollToTop = (delay = 50) => {
//     setTimeout(() => {
//       if (scrollContainerRef.current) {
//         scrollContainerRef.current.scrollTop = 0;
//         scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
//       }
      
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//       document.documentElement.scrollTop = 0;
//       document.body.scrollTop = 0;
      
//       const mainContent = document.querySelector('main .overflow-auto');
//       if (mainContent) {
//         mainContent.scrollTop = 0;
//         mainContent.scrollTo({ top: 0, behavior: 'smooth' });
//       }
//     }, delay);
//   };

//   const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

//   // Close sidebar when section changes on mobile
//   const handleSectionChange = (section) => {
//     setActiveSection(section);
//     setCurrentView('list');
//     setCurrentStrategy(null);
//     setIsSidebarOpen(false); // Close mobile sidebar
//     scrollToTop(100);
//   };

//   // Update unified dashboard data when prop changes
// // Replace the useEffect in ComprehensiveDashboard with this:
// useEffect(() => {
//   // For new users without investment data, don't fetch dashboard data
//   if (userStatus?.userType === 'kyc_needed' || userStatus?.stage === 'kyc_submission') {
//     console.log('📝 New user detected - skipping dashboard data fetch');
//     setIsLoading(false);
//     return;
//   }

//   if (!dashboardData && !isLoading) {
//     console.log('🔄 Fetching dashboard data...');
//     fetchUnifiedDashboardData();
//   } else if (dashboardData) {
//     console.log('📊 Using provided dashboard data');
//     setUnifiedDashboardData(dashboardData);
    
//     const transformedInvestments = transformStrategiesToInvestments(dashboardData.strategies);
//     setInvestments(transformedInvestments);
//     setSipData(dashboardData.sip?.overview);
//     setIsLoading(false);
//   } else {
//     // No dashboard data and not loading - set loading to false for new users
//     setIsLoading(false);
//   }
// }, [userStatus]);

//   useEffect(() => {
//     if (dashboardData && !isLoading) {
//       console.log('📊 Dashboard data prop updated');
//       setUnifiedDashboardData(dashboardData);
      
//       const transformedInvestments = transformStrategiesToInvestments(dashboardData.strategies);
//       setInvestments(transformedInvestments);
//       setSipData(dashboardData.sip?.overview);
//     }
//   }, [dashboardData]);

//   useEffect(() => {
//     updateBreadcrumb();
//   }, [activeSection, currentStrategy, currentView]);

//   useEffect(() => {
//     const scrollToTop = () => {
//       if (scrollContainerRef.current) {
//         scrollContainerRef.current.scrollTo({
//           top: 0,
//           behavior: 'smooth'
//         });
//       }
      
//       window.scrollTo({
//         top: 0,
//         behavior: 'smooth'
//       });
//     };

//     setTimeout(scrollToTop, 100);
//   }, [activeSection, currentView, currentStrategy]);

//   const fetchUnifiedDashboardData = async () => {
//     if (isLoading) {
//       console.log('⏳ Already loading, skipping duplicate call');
//       return;
//     }

//     try {
//       setIsLoading(true);
//       setError(null);
      
//       const token = localStorage.getItem('token');
      
//       const controller = new AbortController();
//       const timeoutId = setTimeout(() => controller.abort(), 30000);

//       console.log('🚀 Starting dashboard API call...');
//       const startTime = performance.now();

//       const dashboardResponse = await fetch(`${API_URL}/api/client/dashboard`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include',
//         signal: controller.signal
//       });

//       clearTimeout(timeoutId);
//       const endTime = performance.now();
//       console.log(`⏱️ Dashboard API call took: ${(endTime - startTime).toFixed(2)}ms`);

//       if (dashboardResponse.ok) {
//         const unifiedData = await dashboardResponse.json();
//         console.log('✅ Dashboard data received successfully');
        
//         setUnifiedDashboardData(unifiedData);
        
//         const transformedInvestments = transformStrategiesToInvestments(unifiedData.strategies);
//         setInvestments(transformedInvestments);
        
//         setSipData(unifiedData.sip?.overview);
//       } else {
//         console.log('❌ Dashboard API failed, trying fallback...');
//         await fetchLegacyData();
//       }

//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.error('🚨 Dashboard request timed out after 30 seconds');
//         setError('Request timed out. Please check your connection and try again.');
//       } else {
//         console.error('🚨 Dashboard fetch error:', error);
//         setError(error.message);
        
//         try {
//           await fetchLegacyData();
//         } catch (fallbackError) {
//           console.error('🚨 Fallback also failed:', fallbackError);
//         }
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchLegacyData = async () => {
//     try {
//       const token = localStorage.getItem('token');

//       const investmentsResponse = await fetch(`${API_URL}/api/client/investments`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include'
//       });

//       if (investmentsResponse.ok) {
//         const investmentsData = await investmentsResponse.json();
//         setInvestments(investmentsData || []);
//       }

//       const sipResponse = await fetch(`${API_URL}/api/client/sip-summary`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include'
//       });

//       if (sipResponse.ok) {
//         const sipSummary = await sipResponse.json();
//         setSipData(sipSummary);
//       }

//     } catch (error) {
//       console.error('Error fetching legacy data:', error);
//     }
//   };

//   const handleViewSIPDashboard = (plan) => {
//     console.log('Navigating to SIP dashboard for plan:', plan);
//     setActiveSection('sip-dashboard');
//     setCurrentStrategy(plan);
//   };

// const transformStrategiesToInvestments = (strategies) => {
//   if (!strategies || !Array.isArray(strategies)) {
//     return [];
//   }


//     const result = strategies
//       .filter(strategy => strategy.type !== 'sip')
//       .map(strategy => ({
//         portfolioId: strategy.portfolioId,
//         portfolioType: strategy.portfolioType,
//         investmentAmount: strategy.investmentAmount,
//         currentValue: strategy.currentValue,
//         numberOfShares: 0,
//         entryPrice: 0,
//         hwm: strategy.investmentAmount,
//         profits: strategy.profits,
//         feesDue: 0,
//         valueAfterFees: strategy.currentValue,
//         perfFee: 0.2,
//         isVault: strategy.isVault,
//         denomination: strategy.denomination,
        
//         totalInvestedDenom: strategy.totalInvestedDenom,
//         currentValueDenom: strategy.currentValueDenom,
//         denominationAsset: strategy.denominationAsset
//       }));


//     return result;
//   };

//   const handleRefresh = async () => {
//     setIsRefreshing(true);
//     await fetchUnifiedDashboardData();
//     if (onStatusUpdate) {
//       onStatusUpdate();
//     }
//     setIsRefreshing(false);
//   };

//   const updateBreadcrumb = () => {
//     let breadcrumbs = [];
    
//     switch (activeSection) {
//       case 'strategies':
//         breadcrumbs = [
//           { label: 'Investment Strategies', href: null }
//         ];
        
//         if (currentView === 'detail' && currentStrategy) {
//           let categoryLabel = 'Strategies';
//           if (currentStrategy.category === 'Vault') {
//             categoryLabel = 'Vaults';
//           } else if (currentStrategy.category === 'Portfolio') {
//             categoryLabel = 'Portfolios';
//           } else if (currentStrategy.category === 'SIP') {
//             categoryLabel = 'SIP Plans';
//           }
          
//           breadcrumbs = [
//             { label: 'Investment Strategies', href: 'strategies_list' },
//             { label: categoryLabel, href: 'category_list' },
//             { label: currentStrategy.name || 'Strategy Detail', href: null }
//           ];
//         }
//         break;
        
//       case 'portfolio':
//         breadcrumbs = [
//           { label: 'Portfolio Overview', href: null }
//         ];
//         break;
        
//       case 'profile':
//         breadcrumbs = [
//           { label: 'Profile Settings', href: null }
//         ];
//         break;
        
//       default:
//         breadcrumbs = [
//           { label: 'Investment Strategies', href: null }
//         ];
//     }
    
//     setBreadcrumbPath(breadcrumbs);
//   };

//   const handleBreadcrumbNavigation = (href) => {
//     switch (href) {
//       case 'strategies_list':
//         setCurrentView('list');
//         setCurrentStrategy(null);
//         break;
//       case 'category_list':
//         setCurrentView('list');
//         setCurrentStrategy(null);
//         break;
//       default:
//         break;
//     }
    
//     setTimeout(() => {
//       if (scrollContainerRef.current) {
//         scrollContainerRef.current.scrollTop = 0;
//         scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
//       }
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//       document.documentElement.scrollTop = 0;
//       document.body.scrollTop = 0;
//     }, 50);
//   };

//   const handleStrategySelect = (strategy) => {
//     setCurrentStrategy(strategy);
//     setCurrentView('detail');
    
//     setTimeout(() => {
//       if (scrollContainerRef.current) {
//         scrollContainerRef.current.scrollTop = 0;
//         scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
//       }
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//       document.documentElement.scrollTop = 0;
//       document.body.scrollTop = 0;
//     }, 100);
//   };

// const hasPortfolioInvestments = useMemo(() => {
//   if (unifiedDashboardData?.strategies) {
//     return unifiedDashboardData.strategies.some(s => 
//       s.type !== 'sip' && s.currentValue > 0
//     );
//   }
//   return investments && investments.length > 0 && investments.some(inv => inv.currentValue > 0);
// }, [unifiedDashboardData, investments]);

// const hasSIPInvestments = useMemo(() => {
//   if (unifiedDashboardData?.sip?.overview) {
//     return unifiedDashboardData.sip.overview.currentValue > 0;
//   }
//   return sipData && sipData.currentValue > 0;
// }, [unifiedDashboardData, sipData]);

// const isKYCCompleted = userStatus?.kycStatus === 'verified';
// const isKYCPending = userStatus?.kycStatus === 'submitted' || userStatus?.kycStatus === 'pending';
// const isKYCRejected = userStatus?.kycStatus === 'rejected';
// const needsKYC = userStatus?.kycStatus === 'not_submitted' || !userStatus?.kycStatus;

//   const enhancedClient = useMemo(() => {
//     if (!client || !unifiedDashboardData?.summary) return client;

//     return {
//       ...client,
//       initialInvestment: unifiedDashboardData.summary.totalInvestment,
//       withdrawn: unifiedDashboardData.summary.totalWithdrawn,
//       currentValue: unifiedDashboardData.summary.currentValue,
//       totalReturn: unifiedDashboardData.summary.totalReturn,
//       profitLoss: unifiedDashboardData.summary.profitLoss
//     };
//   }, [client, unifiedDashboardData]);

// const getBannerContent = () => {
//   // Use userStatus.kycStatus for accurate status checking
//   const kycStatus = userStatus?.kycStatus;
  
//   if (kycStatus === 'not_submitted' || !kycStatus) {
//     return {
//       type: 'warning',
//       icon: AlertCircle,
//       message: 'Complete your KYC verification to start investing',
//       action: 'Complete KYC',
//       onClick: () => handleSectionChange('profile')
//     };
//   }
  
//   if (kycStatus === 'submitted' || kycStatus === 'pending') {
//     return {
//       type: 'info',
//       icon: Info,
//       message: 'Your KYC is under review. You will be notified once approved.',
//       action: null
//     };
//   }
  
//   // NEW: Add rejected status banner
//   if (kycStatus === 'rejected') {
//     return {
//       type: 'error',
//       icon: AlertCircle,
//       message: 'Your KYC application was rejected. Please resubmit with corrections.',
//       action: 'Resubmit KYC',
//       onClick: () => handleSectionChange('profile')
//     };
//   }
  
// if (kycStatus === 'verified' && !hasPortfolioInvestments && !hasSIPInvestments) {
//   return {
//     type: 'success',
//     icon: Info,
//     message: 'KYC approved! Contact your advisor to start investing',
// action: 'Contact Advisor',
// onClick: handleContactAdvisor
//   };
// }
  
//   return null;
// };


//   const bannerContent = getBannerContent();
  



// // UPDATE: Fix the PortfolioSection logic
// const PortfolioSection = () => {
//   if (!hasPortfolioInvestments && !hasSIPInvestments) {
//     return (
//       <div className="space-y-6 lg:space-y-8" style={{fontFamily: 'Lexend, sans-serif'}}>
//         <div className="text-center py-6 lg:py-16">
//           {needsKYC ? (
//             <div className="max-w-md mx-auto px-4">
//               <div className="w-12 h-12 lg:w-16 lg:h-16 bg-yellow-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//                 <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-yellow-500" />
//               </div>
//               <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>Complete KYC to Access Portfolio</h3>
//               <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 Complete your KYC verification to start building your investment portfolio.
//               </p>
//               <button 
//                 onClick={() => handleSectionChange('profile')}
//                 className="inline-flex items-center px-4 lg:px-6 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors text-sm lg:text-base"
//                 style={{fontFamily: 'Lexend, sans-serif'}}
//               >
//                 Complete KYC Process
//               </button>
//             </div>
//           ) : isKYCPending ? (
//             <div className="max-w-md mx-auto px-4">
//               <div className="w-12 h-12 lg:w-16 lg:h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//                 <Info className="h-6 w-6 lg:h-8 lg:w-8 text-[#676DFF]" />
//               </div>
//               <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>KYC Under Review</h3>
//               <p className="text-[#B8B8B8] leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 Your KYC verification is being processed. You'll be able to access your portfolio once approved.
//               </p>
//             </div>
//           ) : isKYCRejected ? (
//             <div className="max-w-md mx-auto px-4">
//               <div className="w-12 h-12 lg:w-16 lg:h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//                 <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-red-500" />
//               </div>
//               <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>KYC Application Rejected</h3>
//               <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 Your KYC application was rejected. Please review the feedback and resubmit with corrections.
//               </p>
//               <button 
//                 onClick={() => handleSectionChange('profile')}
//                 className="inline-flex items-center px-4 lg:px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors text-sm lg:text-base"
//                 style={{fontFamily: 'Lexend, sans-serif'}}
//               >
//                 Resubmit KYC
//               </button>
//             </div>
//           ) : (
//             <div className="max-w-md mx-auto px-4">
//               <div className="w-12 h-12 lg:w-16 lg:h-16 bg-green-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//                 <Wallet className="h-6 w-6 lg:h-8 lg:w-8 text-green-500" />
//               </div>
//               <h3 className="text-base lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>Contact Advisor to Begin Your Portfolio Journey</h3>
//               <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 Your KYC is approved! Contact your advisor to start building your investment portfolio.
//               </p>
// <button 
//   onClick={handleContactAdvisor}
//   className="inline-flex items-center px-4 lg:px-6 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors text-sm lg:text-base" 
//   style={{fontFamily: 'Lexend, sans-serif'}}
// >
//   Contact Advisor
// </button>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   }

// return (
//   <PortfolioOverview 
//     client={enhancedClient} 
//     investments={investments} 
//     sipData={unifiedDashboardData?.sip}
//     onRefresh={handleRefresh}
//     onViewSIP={handleViewSIPDashboard}
//     userStatus={userStatus}
//     onNavigateToProfile={() => handleSectionChange('profile')}
//   />
// );
// };

// const renderBanner = () => {
//   if (!bannerContent) return null;

//   const colors = {
//     warning: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-400',
//     info: 'bg-[#676DFF]/10 border-[#676DFF]/20 text-[#676DFF]',
//     success: 'bg-green-500/10 border-green-500/20 text-green-400',
//     error: 'bg-red-500/10 border-red-500/20 text-red-400'  // NEW: Add error styling
//   };

//   return (
//     <div className={`mb-6 lg:mb-8 p-3 lg:p-4 rounded-xl border backdrop-blur ${colors[bannerContent.type]}`} style={{fontFamily: 'Lexend, sans-serif'}}>
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//         <div className="flex items-center space-x-3">
//           <bannerContent.icon className="h-4 w-4 lg:h-5 lg:w-5 flex-shrink-0" />
//           <p className="font-medium text-sm lg:text-base">{bannerContent.message}</p>
//         </div>
//         {bannerContent.action && (
//           <button 
//             onClick={bannerContent.onClick}
//             className="px-3 lg:px-4 py-2 bg-[#676DFF] hover:bg-[#5A60E8] text-white text-xs lg:text-sm font-medium rounded-lg transition-colors flex-shrink-0"
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             {bannerContent.action}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

//   const renderContent = () => {
//     switch (activeSection) {
// case 'strategies':
//   return <StrategiesSection 
//   userStatus={userStatus} 
//   isKYCCompleted={isKYCCompleted} 
//   onNavigateToProfile={() => handleSectionChange('profile')}
//   onStrategySelect={handleStrategySelect}
//   currentView={currentView}
//   currentStrategy={currentStrategy}
//   dashboardData={unifiedDashboardData}
//   client={client} // Add this line
// />;
//       case 'portfolio':
//         return <PortfolioSection />;
//       case 'profile':
//         return <ProfileSection client={client} userStatus={userStatus} onStatusUpdate={onStatusUpdate} />;
//       case 'sip-dashboard':
//         return <SIPDashboard 
//           client={client} 
//           sipData={unifiedDashboardData?.sip}
//           selectedPlan={currentStrategy}
//           onBack={() => handleSectionChange('portfolio')}
//         />;
//       default:
        
//   return <StrategiesSection 
//     userStatus={userStatus} 
//     kycStatus={userStatus?.kycStatus || 'not_completed'}
//     isKYCCompleted={isKYCCompleted} 
//     onNavigateToProfile={() => handleSectionChange('profile')}
//     onStrategySelect={handleStrategySelect}
//     currentView={currentView}
//     currentStrategy={currentStrategy}
//     dashboardData={unifiedDashboardData} 
//   />;

//       case 'add-funds':
//       return <AddFundsSection 
//         client={client} 
//         userStatus={userStatus}
//       />;
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A] px-4">
//         <div className="text-center">
//           <div className="w-12 h-12 lg:w-16 lg:h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//             <div className="w-6 h-6 lg:w-8 lg:h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
//           </div>
//           <div className="text-lg lg:text-xl font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>Loading dashboard...</div>
//           <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Fetching your investment data
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A] px-4">
//         <div className="text-center p-6 lg:p-8 bg-[#151515] rounded-2xl border border-[#676DFF]/20 w-full max-w-md">
//           <div className="w-12 h-12 lg:w-16 lg:h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
//             <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-red-400" />
//           </div>
//           <div className="text-red-400 font-semibold mb-2 text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>Dashboard Error</div>
//           <div className="text-[#E0E0E0] mb-4 text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>{error}</div>
//           <button 
//             onClick={handleRefresh}
//             className="px-4 py-2 bg-[#676DFF] hover:bg-[#5A60E8] text-white text-sm font-medium rounded-lg transition-colors"
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             Try Again
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const userName = client?.Name || userStatus?.name || 'User';
//   const displayName = userName.split(' ')[0];
//   const userInitials = userName.split(' ').map(n => n[0]).join('').toUpperCase();

//   // Navigation items for easier management
//   const navigationItems = [
//     {
//       id: 'strategies',
//       label: 'Investment Strategies',
//       icon: (
//         <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//           <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
//           <rect x="9" y="9" width="6" height="6"></rect>
//         </svg>
//       ),
//       section: 'PORTFOLIO'
//     },
//     {
//       id: 'portfolio',
//       label: 'Portfolio Dashboard',
//       icon: (
//         <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//           <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
//         </svg>
//       ),
//       section: 'PORTFOLIO'
//     },
//     {
//       id: 'profile',
//       label: 'Profile Settings',
//       icon: (
//         <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//           <circle cx="12" cy="7" r="4"></circle>
//         </svg>
//       ),
//       section: 'ACCOUNT',
//       badge: needsKYC ? { text: 'KYC', color: 'bg-yellow-500/20 text-yellow-400' } : 
//              isKYCPending ? { text: 'Pending', color: 'bg-[#676DFF]/20 text-[#676DFF]' } : null
//     },
//         {
//     id: 'add-funds',
//     label: 'Add Funds',
//     icon: (
//       <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <circle cx="12" cy="12" r="10"></circle>
//         <line x1="12" y1="8" x2="12" y2="16"></line>
//         <line x1="8" y1="12" x2="16" y2="12"></line>
//       </svg>
//     ),
//     section: 'SERVICES',
//     badge: null
//   }

//   ];



//   return (
//     <div className="flex h-screen bg-[#0A0A0A] text-white overflow-hidden" style={{fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'}}>
//       {/* Mobile Sidebar Overlay */}
//       {isSidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
//           onClick={() => setIsSidebarOpen(false)}
//         />
//       )}

//       {/* Sidebar */}
//       <aside className={`
//         fixed lg:static inset-y-0 left-0 z-50
//         w-80 max-w-[85vw] sm:w-80 lg:w-80 
//         bg-[#151515]/95 backdrop-blur 
//         border-r border-[#676DFF]/20 
//         flex flex-col
//         transform transition-transform duration-300 ease-in-out
//         ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
//       `}>
//         {/* Mobile Close Button */}
//         <button
//           onClick={() => setIsSidebarOpen(false)}
//           className="absolute top-4 right-4 lg:hidden p-2 text-[#B8B8B8] hover:text-white hover:bg-[#676DFF]/10 rounded-lg transition-colors"
//         >
//           <X className="h-5 w-5" />
//         </button>

//         {/* Logo Section */}
//         <div className="p-6 lg:p-8 border-b border-[#676DFF]/10">
//           <div className="flex items-center mb-4 lg:mb-6">
//             <img 
//               src="/images/logoOnly.png" 
//               alt="AB Nexus Logo" 
//               className="w-7 h-7 lg:w-14 lg:h-14 mr-3"
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 e.target.nextSibling.style.display = 'block';
//               }}
//             />
//             <div className="w-7 h-7 lg:w-8 lg:h-8 mr-3 relative" style={{display: 'none'}}>
//               <div className="w-full h-full relative">
//                 <div className="absolute top-0 left-0 w-3 h-3 lg:w-4 lg:h-4 border-2 border-white border-r-0 border-b-0"></div>
//                 <div className="absolute bottom-1 right-1 lg:bottom-1.5 lg:right-1.5 w-3 h-3 lg:w-4 lg:h-4 border-2 border-white border-l-0 border-t-0 bg-[#676DFF]/30"></div>
//                 <div className="absolute bottom-0 left-1.5 lg:left-2 w-2.5 h-1 lg:w-3 lg:h-1.5 bg-[#676DFF]"></div>
//               </div>
//             </div>
//             <div className="text-lg lg:text-xl font-semibold text-white tracking-wider" style={{fontFamily: 'Lexend, sans-serif'}}>AB NEXUS</div>
//           </div>
//           <div className="text-left">
//             <div className="text-sm text-[#B8B8B8] font-normal" style={{fontFamily: 'Lexend, sans-serif'}}>Welcome back, {displayName}</div>
//             {unifiedDashboardData?.summary && (
//               <div className="mt-2 text-xs text-[#808080]" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 Portfolio: {new Intl.NumberFormat('en-US', {
//                   style: 'currency',
//                   currency: 'USD',
//                   minimumFractionDigits: 0,
//                   maximumFractionDigits: 0
//                 }).format(unifiedDashboardData.summary.currentValue)}
//               </div>
//             )}
//           </div>
//         </div>
        
//         {/* Navigation Menu */}
//         <nav className="flex-1 p-4 lg:p-6 overflow-y-auto">
//           <div className="space-y-6">
//             {/* Portfolio Section */}
//             <div>
//               <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-3 lg:mb-4 px-2" style={{fontFamily: 'Lexend, sans-serif'}}>PORTFOLIO</div>
//               <div className="space-y-1">
//                 {navigationItems.filter(item => item.section === 'PORTFOLIO').map((item) => (
//                   <button
//                     key={item.id}
//                     onClick={() => handleSectionChange(item.id)}
//                     className={`w-full flex items-center px-4 lg:px-6 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
//                       activeSection === item.id
//                         ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
//                         : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
//                     }`}
//                     style={{fontFamily: 'Lexend, sans-serif'}}
//                   >
//                     <span className="mr-3">{item.icon}</span>
//                     <span className="flex-1 text-left">{item.label}</span>
//                     {item.badge && (
//                       <span className={`text-xs px-2 py-0.5 rounded-full ${item.badge.color}`}>
//                         {item.badge.text}
//                       </span>
//                     )}
//                   </button>
//                 ))}
//               </div>
//             </div>
            
//             {/* Account Section */}
//             <div>
//               <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-3 lg:mb-4 px-2" style={{fontFamily: 'Lexend, sans-serif'}}>ACCOUNT</div>
//               <div className="space-y-1">
//                 {navigationItems.filter(item => item.section === 'ACCOUNT').map((item) => (
//                   <button
//                     key={item.id}
//                     onClick={() => handleSectionChange(item.id)}
//                     className={`w-full flex items-center px-4 lg:px-6 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
//                       activeSection === item.id
//                         ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
//                         : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
//                     }`}
//                     style={{fontFamily: 'Lexend, sans-serif'}}
//                   >
//                     <span className="mr-3">{item.icon}</span>
//                     <span className="flex-1 text-left">{item.label}</span>
//                     {item.badge && (
//                       <span className={`text-xs px-2 py-0.5 rounded-full ${item.badge.color}`}>
//                         {item.badge.text}
//                       </span>
//                     )}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//             {/* Services Section */}
//     <div>
//       <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-3 lg:mb-4 px-2">
//         SERVICES
//       </div>
//       <div className="space-y-1">
//         {navigationItems.filter(item => item.section === 'SERVICES').map((item) => (
//           <button
//             key={item.id}
//             onClick={() => handleSectionChange(item.id)}
//             className={`w-full flex items-center px-4 lg:px-6 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
//               activeSection === item.id
//                 ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
//                 : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
//             }`}
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             <span className="mr-3">{item.icon}</span>
//             <span className="flex-1 text-left">{item.label}</span>
//           </button>
//         ))}
//       </div>
//     </div>

//         </nav>
        
        
//         {/* Bottom Actions */}
//         <div className="p-4 lg:p-6 border-t border-[#676DFF]/10">
//           <button 
//             onClick={() => {
//               onLogout();
//               setIsSidebarOpen(false);
//             }}
//             className="w-full flex items-center justify-center px-4 py-3 text-sm font-medium text-[#E0E0E0] border border-[#505050] rounded-lg hover:bg-[#676DFF]/10 transition-colors"
//             style={{fontFamily: 'Lexend, sans-serif'}}
//           >
//             <LogOut className="mr-2 h-4 w-4" />
//             Logout
//           </button>
//         </div>
//       </aside>

// {/* Main Content */}
//       <main className="flex-1 flex flex-col overflow-hidden">
//         {/* Top Bar */}
//         <header className="bg-[#151515]/95 backdrop-blur border-b border-[#676DFF]/20 px-4 lg:px-8 py-4 lg:py-5 flex justify-between items-center">
//           <div className="flex items-center flex-1">
//             {/* Mobile Menu Button */}
//             <button
//               onClick={() => setIsSidebarOpen(true)}
//               className="lg:hidden p-2 mr-3 text-[#B8B8B8] hover:text-white hover:bg-[#676DFF]/10 rounded-lg transition-colors"
//             >
//               <Menu className="h-5 w-5" />
//             </button>

//             <div className="flex-1">
//               <h1 className="text-lg lg:text-2xl font-semibold text-white tracking-tight mb-1 lg:mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
//                 {activeSection === 'strategies' ? 'Investment Strategies' :
//                  activeSection === 'portfolio' ? 'Portfolio Overview' :
//                  activeSection === 'sip-dashboard' ? 'SIP Dashboard' :
//                  'Profile Settings'}
//               </h1>
              
//               {/* Show breadcrumb when in detail view */}
//               {(currentView === 'detail' && currentStrategy) && (
//                 <div className="hidden sm:block">
//                   <Breadcrumb 
//                     items={breadcrumbPath} 
//                     onNavigate={handleBreadcrumbNavigation}
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
          
//           <div className="flex items-center space-x-3 lg:space-x-4">
//             {/* Quick stats in header - Hidden on mobile, shown on larger screens */}
//             {enhancedClient && activeSection === 'strategies' && (
//               <div className="hidden xl:flex items-center space-x-4 lg:space-x-6 text-sm">
//                 <div className="text-center">
//                   <div className="text-[#B8B8B8] text-xs">Current Value</div>
//                   <div className="text-white font-semibold text-sm">
//                     {new Intl.NumberFormat('en-US', {
//                       style: 'currency',
//                       currency: 'USD',
//                       minimumFractionDigits: 0,
//                       maximumFractionDigits: 0
//                     }).format(enhancedClient.currentValue)}
//                   </div>
//                 </div>
//                 <div className="text-center">
//                   <div className="text-[#B8B8B8] text-xs">Total Return</div>
//                   <div className={`font-semibold text-sm ${(() => {
//                     const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
//                     const returnPercentage = netInvestment > 0 
//                       ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
//                       : 0;
//                     return returnPercentage >= 0 ? 'text-green-400' : 'text-red-400';
//                   })()}`}>
//                     {(() => {
//                       const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
//                       const returnPercentage = netInvestment > 0 
//                         ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
//                         : 0;
//                       return returnPercentage >= 0 ? '+' : '';
//                     })()}{(() => {
//                       const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
//                       const returnPercentage = netInvestment > 0 
//                         ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
//                         : 0;
//                       return returnPercentage.toFixed(2);
//                     })()}%
//                   </div>
//                 </div>
//               </div>
//             )}
            
//             {/* User Avatar */}
//             <div className="w-8 h-8 lg:w-9 lg:h-9 rounded-full bg-gradient-to-r from-[#676DFF] to-[#5A60E8] flex items-center justify-center text-white font-semibold text-xs lg:text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
//               {userInitials}
//             </div>
//           </div>
//         </header>

//         {/* Mobile Breadcrumb - Show on mobile when in detail view */}
//         {(currentView === 'detail' && currentStrategy) && (
//           <div className="sm:hidden px-4 py-3 border-b border-[#676DFF]/10">
//             <Breadcrumb 
//               items={breadcrumbPath} 
//               onNavigate={handleBreadcrumbNavigation}
//             />
//           </div>
//         )}

//         {/* Content Area */}
//         <div className="flex-1 overflow-auto" ref={scrollContainerRef}>
//           <div className="p-4 lg:p-8 max-w-[1600px] mx-auto">
//             {renderBanner()}
//             {renderContent()}
//           </div>
//         </div>
        
//       </main>

//       {/* Modals */}
//       <KYCStatusModal 
//         isOpen={showKYCModal}
//         onClose={() => setShowKYCModal(false)}
//         kycStatus={currentKycStatus}
//         onNavigateToProfile={() => handleSectionChange('profile')}
//       />

//       <StrategySelectionModal
//         isOpen={showStrategySelectionModal}
//         onClose={() => setShowStrategySelectionModal(false)}
//         strategies={availableStrategies}
//         clickedStrategy={clickedStrategy}
//         onProceedToInvestment={(strategies) => {
//           setSelectedStrategiesForInvestment(strategies);
//           setShowStrategySelectionModal(false);
//           setShowInvestmentModal(true);
//         }}
//       />

//       <InvestmentModal 
//         isOpen={showInvestmentModal}
//         onClose={() => setShowInvestmentModal(false)}
//         strategy={selectedStrategiesForInvestment}
//         userStatus={userStatus}
//         client={client}
//       />
      
//     </div>
    
//   );
  
// };

// export default ComprehensiveDashboard;


import React, { useState, useEffect, useMemo, useRef  } from 'react';
import PortfolioOverview from './PortfolioOverview';
import { LogOut, ArrowDown, ArrowUp, Download, Wallet, TrendingUp, DollarSign, Target, Users, AlertCircle, Info, User, RefreshCw, ChevronRight, Menu, X, Clock, Sun, Moon, PieChart } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/Avatar";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/cards";
import StrategiesSection from './StrategiesSection';
import ProfileSection from './ProfileSection';
import Breadcrumb from './Breadcrumb';
import SIPDashboard from './SIPDashboard';
import AddFundsSection from './AddFundsSection';
import TransactionHistory from './TransactionHistory';
import LPPositionsSection from './LPPositionsSection';
import { createClient } from '@supabase/supabase-js';
import { useTheme } from '../theme/ThemeContext';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);
// Strategy Selection Modal Component
const StrategySelectionModal = ({ isOpen, onClose, strategies, clickedStrategy, onProceedToInvestment }) => {
  const [selectedStrategies, setSelectedStrategies] = useState([]);

  useEffect(() => {
    if (isOpen && clickedStrategy) {
      setSelectedStrategies([clickedStrategy.id]);
    } else if (!isOpen) {
      setSelectedStrategies([]);
    }
  }, [isOpen, clickedStrategy]);

  const handleStrategyToggle = (strategyId) => {
    setSelectedStrategies(prev => 
      prev.includes(strategyId) 
        ? prev.filter(id => id !== strategyId)
        : [...prev, strategyId]
    );
  };

  const handleProceed = () => {
    if (selectedStrategies.length > 0) {
      const selectedStrategyObjects = strategies.filter(s => selectedStrategies.includes(s.id));
      onProceedToInvestment(selectedStrategyObjects);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-[#151515] border border-white/10 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
        <div className="p-6 border-b border-white/10">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-white" style={{fontFamily: 'Lexend, sans-serif'}}>
              Select Investment Strategies
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
              <X className="h-5 w-5" />
            </button>
          </div>
          <p className="text-gray-400 mt-2">Choose one or more strategies to invest in:</p>
        </div>
        
        <div className="p-6 max-h-96 overflow-y-auto">
          <div className="space-y-4">
            {strategies.filter(s => s.status !== 'Closed').map((strategy) => (
              <div 
                key={strategy.id}
                className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                  selectedStrategies.includes(strategy.id) 
                    ? 'border-[#676DFF] bg-[#676DFF]/5' 
                    : 'border-white/20 hover:border-white/30'
                }`}
                onClick={() => handleStrategyToggle(strategy.id)}
              >
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <input
                      type="checkbox"
                      checked={selectedStrategies.includes(strategy.id)}
                      onChange={() => handleStrategyToggle(strategy.id)}
                      className="w-4 h-4 text-[#676DFF] border-gray-300 rounded focus:ring-[#676DFF]"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium text-white" style={{fontFamily: 'Lexend, sans-serif'}}>
                          {strategy.name}
                        </h3>
                        <p className="text-sm text-gray-400 mt-1">{strategy.briefSummary}</p>
                      </div>
                      <div className="text-right ml-4">
                        <div className="text-sm font-medium text-gray-400">Category</div>
                        <div className="text-lg font-semibold text-emerald-400">{strategy.category}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="p-6 border-t border-white/10">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-400">
              {selectedStrategies.length} strategy(ies) selected
            </div>
            <div className="flex space-x-3">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-400 border border-white/20 rounded-lg hover:bg-white/5 transition-colors"
                style={{fontFamily: 'Lexend, sans-serif'}}
              >
                Cancel
              </button>
              <button
                onClick={handleProceed}
                disabled={selectedStrategies.length === 0}
                className="px-6 py-2 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
                style={{fontFamily: 'Lexend, sans-serif'}}
              >
                Proceed to Investment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// KYC Status Modal Component 
const KYCStatusModal = ({ isOpen, onClose, kycStatus, onNavigateToProfile }) => {
  if (!isOpen) return null;

  const getStatusConfig = () => {
    switch (kycStatus) {
      case 'not_completed':
        return {
          icon: <AlertCircle className="h-12 w-12 text-amber-500" />,
          title: "Complete KYC to Start Investing",
          message: "Please complete your KYC verification to access our investment strategies.",
          buttonText: "Complete KYC",
          buttonClass: "bg-amber-500 hover:bg-amber-600",
          action: () => { onNavigateToProfile(); onClose(); }
        };
      case 'under_review':
        return {
          icon: <Clock className="h-12 w-12 text-blue-500" />,
          title: "KYC Under Review",
          message: "Your KYC is currently under review. Once approved, you can begin investing.",
          buttonText: "Check Status",
          buttonClass: "bg-blue-500 hover:bg-blue-600",
          action: () => { onNavigateToProfile(); onClose(); }
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-[#151515] border border-white/10 rounded-xl p-6 lg:p-8 max-w-md w-full">
        <div className="flex justify-between items-start mb-6">
          <div className="text-center flex-1">
            <div className="flex justify-center mb-4">{config.icon}</div>
            <h3 className="text-xl font-semibold text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>{config.title}</h3>
            <p className="text-gray-300 text-sm">{config.message}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 border border-white/20 text-gray-300 hover:bg-white/5 font-medium py-3 px-4 rounded-lg transition-colors"
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            Cancel
          </button>
          <button
            onClick={config.action}
            className={`flex-1 text-white font-medium py-3 px-4 rounded-lg transition-colors ${config.buttonClass}`}
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            {config.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

// Investment Modal Component
const InvestmentModal = ({ isOpen, onClose, strategy, userStatus, client }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    selectedStrategy: strategy?.id || '',
    amount: '',
    riskAppetite: 'medium',
    comments: ''
  });

  useEffect(() => {
    if (strategy) {
      const strategyId = Array.isArray(strategy) ? strategy[0]?.id : strategy.id;
      setFormData(prev => ({ ...prev, selectedStrategy: strategyId }));
    }
  }, [strategy]);

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    setIsSubmitting(true);
    
    const userData = {
      client_id: userStatus?.id || client?.id,
      client_name: userStatus?.name || client?.Name,
      client_email: userStatus?.email || client?.email,
      client_phone: userStatus?.phone || client?.phone
    };

    const strategiesArray = Array.isArray(strategy) ? strategy : [strategy];
    const selectedStrategyIds = strategiesArray.map(s => s.id || s.strategyId);
    const strategyNames = strategiesArray.map(s => s.name);

    const investmentData = {
      ...userData,
      selected_strategies: selectedStrategyIds,
      strategy_names: strategyNames,
      investment_amount: parseFloat(formData.amount),
      risk_appetite: formData.riskAppetite,
      comments: formData.comments,
      status: 'pending'
    };

    const { data, error } = await supabase
      .from('investment_requests')
      .insert([investmentData])
      .select();

    if (error) {
      throw error;
    }

    setFormData({
      selectedStrategy: '',
      amount: '',
      riskAppetite: 'medium',
      comments: ''
    });
    onClose();

    const strategyText = strategyNames.length > 1 
      ? `${strategyNames.length} strategies (${strategyNames.join(', ')})`
      : strategyNames[0];
    
    // Replace alert with notification
    if (window.showNotification) {
      window.showNotification({
        type: 'success',
        title: 'Investment Request Submitted!',
        message: `Your request for ${strategyText} has been submitted successfully. We will contact you shortly.`
      });
    }

  } catch (error) {
    console.error('Error submitting investment request:', error);
    
    // Replace alert with notification
    if (window.showNotification) {
      window.showNotification({
        type: 'error',
        title: 'Submission Failed',
        message: 'Failed to submit investment request. Please try again.'
      });
    }
  } finally {
    setIsSubmitting(false);
  }
};

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-[#151515] border border-white/10 rounded-xl p-6 lg:p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-6">
          <h3 className="text-xl font-semibold text-white" style={{fontFamily: 'Lexend, sans-serif'}}>Start Your Investment</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Selected Strateg{Array.isArray(strategy) && strategy.length > 1 ? 'ies' : 'y'}
            </label>
            <div className="bg-white/5 border border-white/10 rounded-lg p-3">
              {Array.isArray(strategy) ? (
                <div className="space-y-2">
                  {strategy.map((s, index) => (
                    <div key={index} className="flex items-center justify-between">
                      <span className="text-white font-medium">{s.name}</span>
                      <span className="text-gray-400 text-sm">{s.category}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <span className="text-white font-medium">{strategy?.name}</span>
                  <span className="text-gray-400 text-sm">{strategy?.category}</span>
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Investment Amount (USD)</label>
            <input
              type="number"
              value={formData.amount}
              onChange={(e) => setFormData(prev => ({ ...prev, amount: e.target.value }))}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:border-[#676DFF] focus:outline-none"
              placeholder="Enter amount"
              min="100"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Risk Appetite</label>
            <div className="grid grid-cols-3 gap-2">
              {['low', 'medium', 'high'].map((risk) => (
                <button
                  key={risk}
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, riskAppetite: risk }))}
                  className={`p-2 rounded-lg border transition-colors text-sm font-medium ${
                    formData.riskAppetite === risk
                      ? 'bg-[#676DFF] border-[#676DFF] text-white'
                      : 'border-white/20 text-gray-300 hover:bg-white/5'
                  }`}
                >
                  {risk.charAt(0).toUpperCase() + risk.slice(1)}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Additional Comments</label>
            <textarea
              value={formData.comments}
              onChange={(e) => setFormData(prev => ({ ...prev, comments: e.target.value }))}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:border-[#676DFF] focus:outline-none h-20 resize-none"
              placeholder="Any specific requirements or questions..."
            />
          </div>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="flex-1 border border-white/20 text-gray-300 hover:bg-white/5 font-medium py-3 px-4 rounded-lg transition-colors disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex-1 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-gray-600 text-white font-medium py-3 px-4 rounded-lg transition-colors"
            >
              {isSubmitting ? 'Submitting...' : 'Submit Investment'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Notification Component
const NotificationBanner = ({ notification, onClose }) => {
  if (!notification) return null;

  const getNotificationStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-500/10 border-green-500/20 text-green-400';
      case 'error':
        return 'bg-red-500/10 border-red-500/20 text-red-400';
      case 'info':
      default:
        return 'bg-[#676DFF]/10 border-[#676DFF]/20 text-[#676DFF]';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md">
      <div className={`p-4 rounded-xl border backdrop-blur ${getNotificationStyles(notification.type)} animate-slide-in`}>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h4 className="font-semibold mb-1" style={{fontFamily: 'Lexend, sans-serif'}}>
              {notification.title}
            </h4>
            <p className="text-sm opacity-90" style={{fontFamily: 'Lexend, sans-serif'}}>
              {notification.message}
            </p>
          </div>
          <button
            onClick={onClose}
            className="ml-3 text-current hover:opacity-70 transition-opacity"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};



const ComprehensiveDashboard = ({ client, userStatus, onLogout, onStatusUpdate, dashboardData, isAdminPreview = false }) => {
  const { theme, toggleTheme } = useTheme();
  const [activeSection, setActiveSection] = useState('strategies');
  const [unifiedDashboardData, setUnifiedDashboardData] = useState(dashboardData);
  const [investments, setInvestments] = useState([]);
  const [sipData, setSipData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Mobile sidebar state
  const scrollContainerRef = useRef(null);
  const [showKYCModal, setShowKYCModal] = useState(false);
const [showStrategySelectionModal, setShowStrategySelectionModal] = useState(false);
const [showInvestmentModal, setShowInvestmentModal] = useState(false);
const [clickedStrategy, setClickedStrategy] = useState(null);
const [selectedStrategiesForInvestment, setSelectedStrategiesForInvestment] = useState([]);
const [currentKycStatus, setCurrentKycStatus] = useState('not_completed');
const [availableStrategies, setAvailableStrategies] = useState([]);
  // Breadcrumb navigation state
  const [breadcrumbPath, setBreadcrumbPath] = useState([]);
  const [currentStrategy, setCurrentStrategy] = useState(null);
  const [currentView, setCurrentView] = useState('list');

  const [notification, setNotification] = useState(null);
  const [hasLPPositions, setHasLPPositions] = useState(false);

  const handleContactAdvisor = () => {
  const actualKycStatus = userStatus?.kycStatus || userStatus?.status || 'not_completed';
  
  let mappedKycStatus;
  if (actualKycStatus === 'verified' || actualKycStatus === 'approved') {
    mappedKycStatus = 'approved';
  } else if (actualKycStatus === 'pending' || actualKycStatus === 'under_review' || actualKycStatus === 'submitted') {
    mappedKycStatus = 'under_review';
  } else {
    mappedKycStatus = 'not_completed';
  }
  
  if (mappedKycStatus === 'approved') {
    setShowStrategySelectionModal(true);
  } else {
    setCurrentKycStatus(mappedKycStatus);
    setShowKYCModal(true);
  }
};

// Add this near the top of your ComprehensiveDashboard component
useEffect(() => {
  // Create global notification function
  window.showNotification = (notificationData) => {
    setNotification(notificationData);
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  };

  // Cleanup
  return () => {
    delete window.showNotification;
  };
}, []);

useEffect(() => {
  setAvailableStrategies([
    {
      id: 'nexus-btc',
      name: 'Nexus BTC',
      briefSummary: 'Build long-term Bitcoin exposure with enhanced yield.',
      category: 'Vault',
      status: 'Live'
    },
    {
      id: 'nexus-eth',
      name: 'Nexus ETH',
      briefSummary: 'Capture Ethereum\'s upside while compounding yield.',
      category: 'Vault',
      status: 'Live'
    },
    {
      id: 'nexus-usd',
      name: 'Nexus USD',
      briefSummary: 'Stable, consistent yield from USD-pegged assets.',
      category: 'Vault',
      status: 'Live'
    },
    {
      id: 'nexus-core',
      name: 'Nexus Core',
      briefSummary: 'The foundation of digital asset investing.',
      category: 'Portfolio',
      status: 'Open'
    },
    {
      id: 'nexus-nova',
      name: 'Nexus Nova',
      briefSummary: 'Positioned for the next era of blockchain adoption.',
      category: 'Portfolio',
      status: 'Open'
    },
    {
      id: 'nexus-alpha',
      name: 'Nexus Alpha',
      briefSummary: 'Harnessing early-stage innovation with active management.',
      category: 'Portfolio',
      status: 'Open'
    },
        {
      id: 'sip-service',
      category: 'SIP',
      name: 'Systematic Investment Plan',
      briefSummary: 'Automated recurring investments across our portfolio strategies with dollar-cost averaging.',
      status: 'Open'
    }
  ]);
}, []);

  useEffect(() => {
    if (isAdminPreview && client?.client_id) {
      const token = localStorage.getItem('adminToken');
      if (!token) return;
      fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/admin/view-as/${client.client_id}/has-lp-positions`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.ok ? res.json() : { hasPositions: false })
        .then((data) => setHasLPPositions(!!data.hasPositions))
        .catch(() => setHasLPPositions(false));
      return;
    }
    if (isAdminPreview) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/client/has-lp-positions`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.ok ? res.json() : { hasPositions: false })
      .then((data) => setHasLPPositions(!!data.hasPositions))
      .catch(() => setHasLPPositions(false));
  }, [client, userStatus, isAdminPreview]);

  const scrollToTop = (delay = 50) => {
    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
        scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      const mainContent = document.querySelector('main .overflow-auto');
      if (mainContent) {
        mainContent.scrollTop = 0;
        mainContent.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, delay);
  };

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // Close sidebar when section changes on mobile
  const handleSectionChange = (section) => {
    setActiveSection(section);
    setCurrentView('list');
    setCurrentStrategy(null);
    setIsSidebarOpen(false); // Close mobile sidebar
    scrollToTop(100);
  };

  // Update unified dashboard data when prop changes
// Replace the useEffect in ComprehensiveDashboard with this:
useEffect(() => {
  if (isAdminPreview) {
    if (dashboardData) {
      setUnifiedDashboardData(dashboardData);
      const transformedInvestments = transformStrategiesToInvestments(dashboardData.strategies);
      setInvestments(transformedInvestments);
      setSipData(dashboardData.sip?.overview);
    }
    setIsLoading(false);
    return;
  }
  // For new users without investment data, don't fetch dashboard data
  if (userStatus?.userType === 'kyc_needed' || userStatus?.stage === 'kyc_submission') {
    console.log('📝 New user detected - skipping dashboard data fetch');
    setIsLoading(false);
    return;
  }

  if (!dashboardData && !isLoading) {
    console.log('🔄 Fetching dashboard data...');
    fetchUnifiedDashboardData();
  } else if (dashboardData) {
    console.log('📊 Using provided dashboard data');
    setUnifiedDashboardData(dashboardData);
    
    const transformedInvestments = transformStrategiesToInvestments(dashboardData.strategies);
    setInvestments(transformedInvestments);
    setSipData(dashboardData.sip?.overview);
    setIsLoading(false);
  } else {
    // No dashboard data and not loading - set loading to false for new users
    setIsLoading(false);
  }
}, [userStatus, isAdminPreview, dashboardData]);

  useEffect(() => {
    if (dashboardData && !isLoading) {
      console.log('📊 Dashboard data prop updated');
      setUnifiedDashboardData(dashboardData);
      
      const transformedInvestments = transformStrategiesToInvestments(dashboardData.strategies);
      setInvestments(transformedInvestments);
      setSipData(dashboardData.sip?.overview);
    }
  }, [dashboardData]);

  useEffect(() => {
    updateBreadcrumb();
  }, [activeSection, currentStrategy, currentView]);

  useEffect(() => {
    const scrollToTop = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    setTimeout(scrollToTop, 100);
  }, [activeSection, currentView, currentStrategy]);

  const fetchUnifiedDashboardData = async () => {
    if (isAdminPreview) return;
    if (isLoading) {
      console.log('⏳ Already loading, skipping duplicate call');
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      console.log('🚀 Starting dashboard API call...');
      const startTime = performance.now();

      const dashboardResponse = await fetch(`${API_URL}/api/client/dashboard`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const endTime = performance.now();
      console.log(`⏱️ Dashboard API call took: ${(endTime - startTime).toFixed(2)}ms`);

      if (dashboardResponse.ok) {
        const unifiedData = await dashboardResponse.json();
        console.log('✅ Dashboard data received successfully');
        
        setUnifiedDashboardData(unifiedData);
        
        const transformedInvestments = transformStrategiesToInvestments(unifiedData.strategies);
        setInvestments(transformedInvestments);
        
        setSipData(unifiedData.sip?.overview);
      } else {
        console.log('❌ Dashboard API failed, trying fallback...');
        await fetchLegacyData();
      }

    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('🚨 Dashboard request timed out after 30 seconds');
        setError('Request timed out. Please check your connection and try again.');
      } else {
        console.error('🚨 Dashboard fetch error:', error);
        setError(error.message);
        
        try {
          await fetchLegacyData();
        } catch (fallbackError) {
          console.error('🚨 Fallback also failed:', fallbackError);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLegacyData = async () => {
    try {
      const token = localStorage.getItem('token');

      const investmentsResponse = await fetch(`${API_URL}/api/client/investments`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      if (investmentsResponse.ok) {
        const investmentsData = await investmentsResponse.json();
        setInvestments(investmentsData || []);
      }

      const sipResponse = await fetch(`${API_URL}/api/client/sip-summary`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      if (sipResponse.ok) {
        const sipSummary = await sipResponse.json();
        setSipData(sipSummary);
      }

    } catch (error) {
      console.error('Error fetching legacy data:', error);
    }
  };

  const handleViewSIPDashboard = (plan) => {
    console.log('Navigating to SIP dashboard for plan:', plan);
    setActiveSection('sip-dashboard');
    setCurrentStrategy(plan);
  };

const transformStrategiesToInvestments = (strategies) => {
  if (!strategies || !Array.isArray(strategies)) {
    return [];
  }


    const result = strategies
      .filter(strategy => strategy.type !== 'sip')
      .map(strategy => ({
        portfolioId: strategy.portfolioId,
        portfolioType: strategy.portfolioType,
        investmentAmount: strategy.investmentAmount,
        currentValue: strategy.currentValue,
        numberOfShares: 0,
        entryPrice: 0,
        hwm: strategy.investmentAmount,
        profits: strategy.profits,
        feesDue: 0,
        valueAfterFees: strategy.currentValue,
        perfFee: 0.2,
        isVault: strategy.isVault,
        denomination: strategy.denomination,
        
        totalInvestedDenom: strategy.totalInvestedDenom,
        currentValueDenom: strategy.currentValueDenom,
        denominationAsset: strategy.denominationAsset
      }));


    return result;
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchUnifiedDashboardData();
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    setIsRefreshing(false);
  };

  const updateBreadcrumb = () => {
    let breadcrumbs = [];
    
    switch (activeSection) {
      case 'strategies':
        breadcrumbs = [
          { label: 'Investment Strategies', href: null }
        ];
        
        if (currentView === 'detail' && currentStrategy) {
          let categoryLabel = 'Strategies';
          if (currentStrategy.category === 'Vault') {
            categoryLabel = 'Vaults';
          } else if (currentStrategy.category === 'Portfolio') {
            categoryLabel = 'Portfolios';
          } else if (currentStrategy.category === 'SIP') {
            categoryLabel = 'SIP Plans';
          }
          
          breadcrumbs = [
            { label: 'Investment Strategies', href: 'strategies_list' },
            { label: categoryLabel, href: 'category_list' },
            { label: currentStrategy.name || 'Strategy Detail', href: null }
          ];
        }
        break;
        
      case 'portfolio':
        breadcrumbs = [
          { label: 'Portfolio Overview', href: null }
        ];
        break;

      case 'transactions':
        breadcrumbs = [
          { label: 'Transaction History', href: null }
        ];
        break;
        
      case 'profile':
        breadcrumbs = [
          { label: 'Profile Settings', href: null }
        ];
        break;
        
      default:
        breadcrumbs = [
          { label: 'Investment Strategies', href: null }
        ];
    }
    
    setBreadcrumbPath(breadcrumbs);
  };

  const handleBreadcrumbNavigation = (href) => {
    switch (href) {
      case 'strategies_list':
        setCurrentView('list');
        setCurrentStrategy(null);
        break;
      case 'category_list':
        setCurrentView('list');
        setCurrentStrategy(null);
        break;
      default:
        break;
    }
    
    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
        scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
  };

  const handleStrategySelect = (strategy) => {
    setCurrentStrategy(strategy);
    setCurrentView('detail');
    
    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
        scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);
  };

const hasPortfolioInvestments = useMemo(() => {
  if (unifiedDashboardData?.strategies) {
    return unifiedDashboardData.strategies.some(s => 
      s.type !== 'sip' && s.currentValue > 0
    );
  }
  return investments && investments.length > 0 && investments.some(inv => inv.currentValue > 0);
}, [unifiedDashboardData, investments]);

const hasSIPInvestments = useMemo(() => {
  if (unifiedDashboardData?.sip?.overview) {
    return unifiedDashboardData.sip.overview.currentValue > 0;
  }
  return sipData && sipData.currentValue > 0;
}, [unifiedDashboardData, sipData]);

const isKYCCompleted = userStatus?.kycStatus === 'verified';
const isKYCPending = userStatus?.kycStatus === 'submitted' || userStatus?.kycStatus === 'pending';
const isKYCRejected = userStatus?.kycStatus === 'rejected';
const needsKYC = userStatus?.kycStatus === 'not_submitted' || !userStatus?.kycStatus;

  const enhancedClient = useMemo(() => {
    if (!client || !unifiedDashboardData?.summary) return client;

    return {
      ...client,
      initialInvestment: unifiedDashboardData.summary.totalInvestment,
      withdrawn: unifiedDashboardData.summary.totalWithdrawn,
      currentValue: unifiedDashboardData.summary.currentValue,
      totalReturn: unifiedDashboardData.summary.totalReturn,
      profitLoss: unifiedDashboardData.summary.profitLoss
    };
  }, [client, unifiedDashboardData]);

const getBannerContent = () => {
  // Use userStatus.kycStatus for accurate status checking
  const kycStatus = userStatus?.kycStatus;
  
  if (kycStatus === 'not_submitted' || !kycStatus) {
    return {
      type: 'warning',
      icon: AlertCircle,
      message: 'Complete your KYC verification to start investing',
      action: 'Complete KYC',
      onClick: () => handleSectionChange('profile')
    };
  }
  
  if (kycStatus === 'submitted' || kycStatus === 'pending') {
    return {
      type: 'info',
      icon: Info,
      message: 'Your KYC is under review. You will be notified once approved.',
      action: null
    };
  }
  
  // NEW: Add rejected status banner
  if (kycStatus === 'rejected') {
    return {
      type: 'error',
      icon: AlertCircle,
      message: 'Your KYC application was rejected. Please resubmit with corrections.',
      action: 'Resubmit KYC',
      onClick: () => handleSectionChange('profile')
    };
  }
  
if (kycStatus === 'verified' && !hasPortfolioInvestments && !hasSIPInvestments) {
  return {
    type: 'success',
    icon: Info,
    message: 'KYC approved! Contact your advisor to start investing',
action: 'Contact Advisor',
onClick: handleContactAdvisor
  };
}
  
  return null;
};


  const bannerContent = getBannerContent();
  



// UPDATE: Fix the PortfolioSection logic
const PortfolioSection = () => {
  if (!hasPortfolioInvestments && !hasSIPInvestments) {
    return (
      <div className="space-y-6 lg:space-y-8" style={{fontFamily: 'Lexend, sans-serif'}}>
        <div className="text-center py-6 lg:py-16">
          {needsKYC ? (
            <div className="max-w-md mx-auto px-4">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-yellow-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-yellow-500" />
              </div>
              <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>Complete KYC to Access Portfolio</h3>
              <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
                Complete your KYC verification to start building your investment portfolio.
              </p>
              <button 
                onClick={() => handleSectionChange('profile')}
                className="inline-flex items-center px-4 lg:px-6 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors text-sm lg:text-base"
                style={{fontFamily: 'Lexend, sans-serif'}}
              >
                Complete KYC Process
              </button>
            </div>
          ) : isKYCPending ? (
            <div className="max-w-md mx-auto px-4">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <Info className="h-6 w-6 lg:h-8 lg:w-8 text-[#676DFF]" />
              </div>
              <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>KYC Under Review</h3>
              <p className="text-[#B8B8B8] leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
                Your KYC verification is being processed. You'll be able to access your portfolio once approved.
              </p>
            </div>
          ) : isKYCRejected ? (
            <div className="max-w-md mx-auto px-4">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-red-500" />
              </div>
              <h3 className="text-lg lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>KYC Application Rejected</h3>
              <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
                Your KYC application was rejected. Please review the feedback and resubmit with corrections.
              </p>
              <button 
                onClick={() => handleSectionChange('profile')}
                className="inline-flex items-center px-4 lg:px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors text-sm lg:text-base"
                style={{fontFamily: 'Lexend, sans-serif'}}
              >
                Resubmit KYC
              </button>
            </div>
          ) : (
            <div className="max-w-md mx-auto px-4">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-green-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <Wallet className="h-6 w-6 lg:h-8 lg:w-8 text-green-500" />
              </div>
              <h3 className="text-base lg:text-xl font-semibold text-white mb-3" style={{fontFamily: 'Lexend, sans-serif'}}>Contact Advisor to Begin Your Portfolio Journey</h3>
              <p className="text-[#B8B8B8] mb-6 lg:mb-8 leading-relaxed text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>
                Your KYC is approved! Contact your advisor to start building your investment portfolio.
              </p>
<button 
  onClick={handleContactAdvisor}
  className="inline-flex items-center px-4 lg:px-6 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors text-sm lg:text-base" 
  style={{fontFamily: 'Lexend, sans-serif'}}
>
  Contact Advisor
</button>
            </div>
          )}
        </div>
      </div>
    );
  }

return (
  <PortfolioOverview 
    client={enhancedClient} 
    investments={investments} 
    sipData={unifiedDashboardData?.sip}
    onRefresh={handleRefresh}
    onViewSIP={handleViewSIPDashboard}
    userStatus={userStatus}
    onNavigateToProfile={() => handleSectionChange('profile')}
    btcLastUpdated={unifiedDashboardData?.btcLastUpdated}
    isAdminPreview={isAdminPreview}
  />
);
};

const renderBanner = () => {
  if (!bannerContent) return null;

  const colors = {
    warning: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-400',
    info: 'bg-[#676DFF]/10 border-[#676DFF]/20 text-[#676DFF]',
    success: 'bg-green-500/10 border-green-500/20 text-green-400',
    error: 'bg-red-500/10 border-red-500/20 text-red-400'  // NEW: Add error styling
  };

  return (
    <div className={`mb-6 lg:mb-8 p-3 lg:p-4 rounded-xl border backdrop-blur ${colors[bannerContent.type]}`} style={{fontFamily: 'Lexend, sans-serif'}}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center space-x-3">
          <bannerContent.icon className="h-4 w-4 lg:h-5 lg:w-5 flex-shrink-0" />
          <p className="font-medium text-sm lg:text-base">{bannerContent.message}</p>
        </div>
        {bannerContent.action && (
          <button 
            onClick={bannerContent.onClick}
            className="px-3 lg:px-4 py-2 bg-[#676DFF] hover:bg-[#5A60E8] text-white text-xs lg:text-sm font-medium rounded-lg transition-colors flex-shrink-0"
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            {bannerContent.action}
          </button>
        )}
      </div>
    </div>
  );
};

  const renderContent = () => {
    switch (activeSection) {
case 'strategies':
  return <StrategiesSection 
  userStatus={userStatus} 
  isKYCCompleted={isKYCCompleted} 
  onNavigateToProfile={() => handleSectionChange('profile')}
  onStrategySelect={handleStrategySelect}
  currentView={currentView}
  currentStrategy={currentStrategy}
  dashboardData={unifiedDashboardData}
  client={client} // Add this line
/>;
      case 'portfolio':
        return <PortfolioSection />;
      case 'transactions':
        return <TransactionHistory clientId={client?.client_id} isAdminPreview={isAdminPreview} />;
      case 'lp-positions':
        return <LPPositionsSection client={client} clientId={client?.client_id} isAdminPreview={isAdminPreview} />;
      case 'profile':
        return <ProfileSection client={client} userStatus={userStatus} onStatusUpdate={onStatusUpdate} />;
      case 'sip-dashboard':
        return <SIPDashboard 
          client={client} 
          sipData={unifiedDashboardData?.sip}
          selectedPlan={currentStrategy}
          onBack={() => handleSectionChange('portfolio')}
        />;
      default:
        
  return <StrategiesSection 
    userStatus={userStatus} 
    kycStatus={userStatus?.kycStatus || 'not_completed'}
    isKYCCompleted={isKYCCompleted} 
    onNavigateToProfile={() => handleSectionChange('profile')}
    onStrategySelect={handleStrategySelect}
    currentView={currentView}
    currentStrategy={currentStrategy}
    dashboardData={unifiedDashboardData} 
  />;

      case 'add-funds':
      return <AddFundsSection 
      key="add-funds-section"  // ← Add this
        client={client} 
        userStatus={userStatus}
      />;
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A] px-4">
        <div className="text-center">
          <div className="w-12 h-12 lg:w-16 lg:h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
            <div className="w-6 h-6 lg:w-8 lg:h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
          </div>
          <div className="text-lg lg:text-xl font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>Loading dashboard...</div>
          <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
            Fetching your investment data
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A] px-4">
        <div className="text-center p-6 lg:p-8 bg-[#151515] rounded-2xl border border-[#676DFF]/20 w-full max-w-md">
          <div className="w-12 h-12 lg:w-16 lg:h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
            <AlertCircle className="h-6 w-6 lg:h-8 lg:w-8 text-red-400" />
          </div>
          <div className="text-red-400 font-semibold mb-2 text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>Dashboard Error</div>
          <div className="text-[#E0E0E0] mb-4 text-sm lg:text-base" style={{fontFamily: 'Lexend, sans-serif'}}>{error}</div>
          <button 
            onClick={handleRefresh}
            className="px-4 py-2 bg-[#676DFF] hover:bg-[#5A60E8] text-white text-sm font-medium rounded-lg transition-colors"
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const userName = client?.Name || userStatus?.name || 'User';
  const displayName = userName.split(' ')[0];
  const userInitials = userName.split(' ').map(n => n[0]).join('').toUpperCase();

  // Navigation items for easier management
  const navigationItems = [
    {
      id: 'strategies',
      label: 'Investment Strategies',
      icon: (
        <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <rect x="9" y="9" width="6" height="6"></rect>
        </svg>
      ),
      section: 'PORTFOLIO'
    },
    {
      id: 'portfolio',
      label: 'Portfolio Dashboard',
      icon: (
        <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
        </svg>
      ),
      section: 'PORTFOLIO'
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: (
        <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 3 21 8 16 13"></polyline>
          <line x1="21" y1="8" x2="9" y2="8"></line>
          <polyline points="8 21 3 16 8 11"></polyline>
          <line x1="3" y1="16" x2="15" y2="16"></line>
        </svg>
      ),
      section: 'PORTFOLIO'
    },
    {
      id: 'lp-positions',
      label: 'Orders',
      icon: <DollarSign className="h-4 w-4 opacity-80" />,
      section: 'PORTFOLIO',
      visible: hasLPPositions
    },
    {
      id: 'profile',
      label: 'Profile Settings',
      icon: (
        <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
      section: 'ACCOUNT',
      badge: needsKYC ? { text: 'KYC', color: 'bg-yellow-500/20 text-yellow-400' } : 
             isKYCPending ? { text: 'Pending', color: 'bg-[#676DFF]/20 text-[#676DFF]' } : null
    },
        {
    id: 'add-funds',
    label: 'Add Funds',
    icon: (
      <svg className="h-4 w-4 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="16"></line>
        <line x1="8" y1="12" x2="16" y2="12"></line>
      </svg>
    ),
    section: 'SERVICES',
    badge: null
  }

  ];



  return (
    <div className="flex h-screen bg-[#0A0A0A] text-white overflow-hidden" style={{fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'}}>
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-80 max-w-[85vw] sm:w-80 lg:w-80 
        bg-[#151515]/95 backdrop-blur 
        border-r border-[#676DFF]/20 
        flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Mobile Close Button */}
        <button
          onClick={() => setIsSidebarOpen(false)}
          className="absolute top-4 right-4 lg:hidden p-2 text-[#B8B8B8] hover:text-white hover:bg-[#676DFF]/10 rounded-lg transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Logo Section */}
        <div className="p-4 lg:p-5 border-b border-[#676DFF]/10">
          <div className="flex items-center mb-3 lg:mb-4">
            <img 
              src={theme === 'light' ? '/logoLight.svg' : '/images/logoOnly.png'} 
              alt="AB Nexus Logo" 
              className="w-7 h-7 lg:w-10 lg:h-10 mr-3"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="w-7 h-7 lg:w-8 lg:h-8 mr-3 relative" style={{display: 'none'}}>
              <div className="w-full h-full relative">
                <div className="absolute top-0 left-0 w-3 h-3 lg:w-4 lg:h-4 border-2 border-white border-r-0 border-b-0"></div>
                <div className="absolute bottom-1 right-1 lg:bottom-1.5 lg:right-1.5 w-3 h-3 lg:w-4 lg:h-4 border-2 border-white border-l-0 border-t-0 bg-[#676DFF]/30"></div>
                <div className="absolute bottom-0 left-1.5 lg:left-2 w-2.5 h-1 lg:w-3 lg:h-1.5 bg-[#676DFF]"></div>
              </div>
            </div>
            <div className="text-lg lg:text-xl font-semibold text-white tracking-wider" style={{fontFamily: 'Lexend, sans-serif'}}>AB NEXUS</div>
          </div>
          <div className="text-left">
            <div className="text-sm text-[#B8B8B8] font-normal" style={{fontFamily: 'Lexend, sans-serif'}}>Welcome back, {displayName}</div>
            {unifiedDashboardData?.summary && (
              <div className="mt-1 text-xs text-[#808080]" style={{fontFamily: 'Lexend, sans-serif'}}>
                Portfolio: {new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(unifiedDashboardData.summary.currentValue)}
              </div>
            )}
          </div>
        </div>
        
        {/* Navigation Menu */}
        <nav className="flex-1 overflow-y-auto p-3 lg:p-4">
          <div className="space-y-5">
            {/* Portfolio Section */}
            <div className="pt-1">
              <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-2 px-2" style={{fontFamily: 'Lexend, sans-serif'}}>PORTFOLIO</div>
              <div className="space-y-1">
                {navigationItems.filter(item => item.section === 'PORTFOLIO' && item.visible !== false).map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleSectionChange(item.id)}
                    className={`w-full flex items-center px-3 lg:px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                      activeSection === item.id
                        ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
                        : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
                    }`}
                    style={{fontFamily: 'Lexend, sans-serif'}}
                  >
                    <span className="mr-3">{item.icon}</span>
                    <span className="flex-1 text-left">{item.label}</span>
                    {item.badge && (
                      <span className={`text-xs px-2 py-0.5 rounded-full ${item.badge.color}`}>
                        {item.badge.text}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
            
            {/* Account Section */}
            <div className="pt-1">
              <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-2 px-2" style={{fontFamily: 'Lexend, sans-serif'}}>ACCOUNT</div>
              <div className="space-y-1">
                {navigationItems.filter(item => item.section === 'ACCOUNT').map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleSectionChange(item.id)}
                    className={`w-full flex items-center px-3 lg:px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                      activeSection === item.id
                        ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
                        : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
                    }`}
                    style={{fontFamily: 'Lexend, sans-serif'}}
                  >
                    <span className="mr-3">{item.icon}</span>
                    <span className="flex-1 text-left">{item.label}</span>
                    {item.badge && (
                      <span className={`text-xs px-2 py-0.5 rounded-full ${item.badge.color}`}>
                        {item.badge.text}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>
            {/* Services Section */}
    <div className="mt-6 pt-1">
      <div className="text-xs text-[#808080] uppercase tracking-wider font-semibold mb-2 px-2">
        SERVICES
      </div>
      <div className="space-y-1">
        {navigationItems.filter(item => item.section === 'SERVICES').map((item) => (
          <button
            key={item.id}
            onClick={() => handleSectionChange(item.id)}
            className={`w-full flex items-center px-3 lg:px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              activeSection === item.id
                ? 'bg-[#676DFF]/15 text-[#676DFF] border-r-3 border-[#676DFF]'
                : 'text-[#E0E0E0] hover:bg-[#676DFF]/10 hover:text-white'
            }`}
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            <span className="mr-3">{item.icon}</span>
            <span className="flex-1 text-left">{item.label}</span>
          </button>
        ))}
      </div>
    </div>

        </nav>
        
        
        {/* Bottom Actions */}
        <div className="p-3 lg:p-4 border-t border-[#676DFF]/10">
          <button 
            onClick={() => {
              onLogout();
              setIsSidebarOpen(false);
            }}
            className="w-full flex items-center justify-center px-4 py-2.5 text-sm font-medium text-[#E0E0E0] border border-[#505050] rounded-lg hover:bg-[#676DFF]/10 transition-colors"
            style={{fontFamily: 'Lexend, sans-serif'}}
          >
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </button>
        </div>
      </aside>

{/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <header className="bg-[#151515]/95 backdrop-blur border-b border-[#676DFF]/20 px-4 lg:px-8 py-4 lg:py-5 flex justify-between items-center">
          <div className="flex items-center flex-1">
            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="lg:hidden p-2 mr-3 text-[#B8B8B8] hover:text-white hover:bg-[#676DFF]/10 rounded-lg transition-colors"
            >
              <Menu className="h-5 w-5" />
            </button>

            <div className="flex-1">
              <h1 className="text-lg lg:text-2xl font-semibold text-white tracking-tight mb-1 lg:mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                {activeSection === 'strategies' ? 'Investment Strategies' :
                 activeSection === 'portfolio' ? 'Portfolio Overview' :
                 activeSection === 'transactions' ? 'Transaction History' :
                 activeSection === 'lp-positions' ? 'Orders' :
                 activeSection === 'sip-dashboard' ? 'SIP Dashboard' :
                 activeSection === 'add-funds' ? 'Add Funds' :
                 'Profile Settings'}
              </h1>
              
              {/* Show breadcrumb when in detail view */}
              {(currentView === 'detail' && currentStrategy) && (
                <div className="hidden sm:block">
                  <Breadcrumb 
                    items={breadcrumbPath} 
                    onNavigate={handleBreadcrumbNavigation}
                  />
                </div>
              )}
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-3 lg:gap-4">
            {/* Mobile View Portfolio Button - Visible on mobile/tablet, hidden on xl+ */}
            {enhancedClient && activeSection === 'strategies' && (
              <button
                onClick={() => handleSectionChange('portfolio')}
                title="View portfolio"
                className="xl:hidden p-2 rounded-lg border border-[#676DFF]/30 bg-[#676DFF]/5 text-[#676DFF] hover:bg-[#676DFF]/10 hover:border-[#676DFF]/50 transition-colors"
              >
                <PieChart className="h-5 w-5" strokeWidth={2} />
              </button>
            )}
            
            {/* Quick stats in header - Hidden on mobile, shown on larger screens */}
            {enhancedClient && activeSection === 'strategies' && (
              <div className="hidden xl:flex items-center space-x-6 text-sm">
                <div className="text-left">
                  <div className="text-[#B8B8B8] text-xs">Current Value</div>
                  <div className="text-white font-semibold text-sm">
                    {new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'USD',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(enhancedClient.currentValue)}
                  </div>
                </div>
                <div className="text-left">
                  <div className="text-[#B8B8B8] text-xs">Total Return</div>
                  <div className={`font-semibold text-sm ${(() => {
                    const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
                    const returnPercentage = netInvestment > 0 
                      ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
                      : 0;
                    return returnPercentage >= 0 ? 'text-green-400' : 'text-red-400';
                  })()}`}>
                    {(() => {
                      const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
                      const returnPercentage = netInvestment > 0 
                        ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
                        : 0;
                      return returnPercentage >= 0 ? '+' : '';
                    })()}{(() => {
                      const netInvestment = (enhancedClient.initialInvestment || 0) - (enhancedClient.withdrawn || 0);
                      const returnPercentage = netInvestment > 0 
                        ? ((enhancedClient.currentValue - netInvestment) / netInvestment * 100)
                        : 0;
                      return returnPercentage.toFixed(2);
                    })()}%
                  </div>
                </div>
              </div>
            )}

            {enhancedClient && activeSection === 'strategies' && (
              <button
                onClick={() => handleSectionChange('portfolio')}
                title="View portfolio"
                className="hidden xl:flex p-2 rounded-lg border border-[#676DFF]/30 bg-[#676DFF]/5 text-[#676DFF] hover:bg-[#676DFF]/10 hover:border-[#676DFF]/50 transition-colors items-center justify-center"
              >
                <PieChart className="h-5 w-5" strokeWidth={2} />
              </button>
            )}
            
            <button
              onClick={toggleTheme}
              className="p-2 lg:px-3 lg:py-2 rounded-lg border border-[#676DFF]/20 bg-white/5 hover:bg-white/10 transition-colors flex items-center justify-center text-sm font-medium"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>

            {/* User Avatar */}
            <button
              onClick={() => handleSectionChange('profile')}
              className="w-8 h-8 lg:w-9 lg:h-9 rounded-full bg-gradient-to-r from-[#676DFF] to-[#5A60E8] flex items-center justify-center text-white font-semibold text-xs lg:text-sm hover:from-[#5A60E8] hover:to-[#4D52D1] transition-all duration-200 cursor-pointer"
              style={{fontFamily: 'Lexend, sans-serif'}}
              title="Profile Settings"
            >
              {userInitials}
            </button>
          </div>
        </header>

        {/* Mobile Breadcrumb - Show on mobile when in detail view */}
        {(currentView === 'detail' && currentStrategy) && (
          <div className="sm:hidden px-4 py-3 border-b border-[#676DFF]/10">
            <Breadcrumb 
              items={breadcrumbPath} 
              onNavigate={handleBreadcrumbNavigation}
            />
          </div>
        )}

        {/* Content Area */}
        <div className="flex-1 overflow-auto" ref={scrollContainerRef}>
          <div className="p-4 lg:p-8 max-w-[1600px] mx-auto">
            {renderBanner()}
            {renderContent()}
          </div>
        </div>
        
      </main>

      {/* Modals */}
      <KYCStatusModal 
        isOpen={showKYCModal}
        onClose={() => setShowKYCModal(false)}
        kycStatus={currentKycStatus}
        onNavigateToProfile={() => handleSectionChange('profile')}
      />

      <StrategySelectionModal
        isOpen={showStrategySelectionModal}
        onClose={() => setShowStrategySelectionModal(false)}
        strategies={availableStrategies}
        clickedStrategy={clickedStrategy}
        onProceedToInvestment={(strategies) => {
          setSelectedStrategiesForInvestment(strategies);
          setShowStrategySelectionModal(false);
          setShowInvestmentModal(true);
        }}
      />

      <InvestmentModal 
        isOpen={showInvestmentModal}
        onClose={() => setShowInvestmentModal(false)}
        strategy={selectedStrategiesForInvestment}
        userStatus={userStatus}
        client={client}
      />

            {/* Notification Banner */}
      <NotificationBanner 
        notification={notification}
        onClose={() => setNotification(null)}
      />
      
    </div>
    
  );
  
};

export default ComprehensiveDashboard;